import { consoleEvents, LoadingStates } from '@pb/utils'
import produce from 'immer'
import { createReducer } from 'redux-act'

import { PointsHistoryState, PointsTransactionsResponse } from '../types'
import * as actions from './actions'

const fetchPointsTransactionsStart = (state: PointsHistoryState): PointsHistoryState =>
  produce(state, (draftState) => {
    draftState.pointsTransactions = {
      type: LoadingStates.Loading,
      data: null,
      error: null,
    }
  })

const fetchPointsTransactionsLoadedFail = (state: PointsHistoryState): PointsHistoryState => {
  consoleEvents.error('Failed to fetch Points Transactions')

  return produce(state, (draftState) => {
    draftState.pointsTransactions = {
      type: LoadingStates.LoadedFail,
      data: null,
      error: 'idk',
    }
  })
}

const fetchPointsTransactionsLoadedSuccess = (
  state: PointsHistoryState,
  pointsTransactionsResponse: PointsTransactionsResponse,
): PointsHistoryState =>
  produce(state, (draftState) => {
    draftState.pointsTransactions = {
      type: LoadingStates.LoadedSuccess,
      data: pointsTransactionsResponse,
      error: null,
    }
  })

const initialState: PointsHistoryState = {
  pointsTransactions: {
    type: LoadingStates.NotLoaded,
    data: null,
    error: null,
  },
}

const reducer = createReducer<PointsHistoryState>((on) => {
  on(actions.fetchPointsTransactionsStart, fetchPointsTransactionsStart)
  on(actions.fetchPointsTransactionsLoadedFail, fetchPointsTransactionsLoadedFail)
  on(actions.fetchPointsTransactionsLoadedSuccess, fetchPointsTransactionsLoadedSuccess)
}, initialState)

export default reducer
